import * as React from 'react';
import './TrackerMilestonePage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ITrackerMilestoneReduxFormState, initialTrackerMilestoneState } from "../../../reducers/reactReduxForms/trackerMilestone";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as TrackerMilestoneActions from '../../../actions/trackerMilestones';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { QALookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';
interface ITrackerMilestonePageParams {
  trackerMilestoneId: number;
}
interface ITrackerMilestonePageProps {
  form: Dtos.TrackerMilestone & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: ITrackerMilestoneReduxFormState;
  location: Location;
  trackerMilestoneId: number;
  match: match<ITrackerMilestonePageParams>;
  history: History;

  // From state
  trackerMilestone: Dtos.TrackerMilestone;
  lookups: Dtos.Lookup[];
  loadingTrackerMilestone: boolean;
  loadTrackerMilestoneSuccess: boolean;
  loadTrackerMilestoneFailure: boolean;
  savingTrackerMilestone: boolean;
  saveTrackerMilestoneSuccess: boolean;
  saveTrackerMilestoneFailure: boolean;
  creatingTrackerMilestone: boolean;
  createTrackerMilestoneSuccess: boolean;
  createTrackerMilestoneFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface ITrackerMilestonePageActions {
  clearTrackerMilestone: TrackerMilestoneActions.ITrackerMilestoneClearActionCreator;
  loadTrackerMilestone: TrackerMilestoneActions.ITrackerMilestoneLoadByIdActionCreator;
  saveTrackerMilestone: TrackerMilestoneActions.ITrackerMilestoneSaveActionCreator;
  createTrackerMilestone: TrackerMilestoneActions.ITrackerMilestoneCreateActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type TrackerMilestonePageProps = ITrackerMilestonePageProps & ITrackerMilestonePageActions;
const reduxFormName: string = "reduxForms.trackerMilestone";
class TrackerMilestonePage extends React.PureComponent<TrackerMilestonePageProps, any> {
  constructor(props: TrackerMilestonePageProps) {
    super(props);
    this.clearTrackerMilestone = this.clearTrackerMilestone.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadTrackerMilestone,
      trackerMilestoneId,
      createTrackerMilestone
    } = this.props;
    if (trackerMilestoneId) {
      loadTrackerMilestone(trackerMilestoneId);
    } else if (!trackerMilestoneId) {
      createTrackerMilestone();
    }
  }
  componentWillReceiveProps(nextProps: TrackerMilestonePageProps) {}
  componentDidUpdate(prevProps: TrackerMilestonePageProps, prevState) {
    const {
      trackerMilestoneId,
      trackerMilestone,
      form,
      navigate,
      loadTrackerMilestone,
      loadingTrackerMilestone,
      loadTrackerMilestoneSuccess,
      createTrackerMilestone,
      creatingTrackerMilestone,
      createTrackerMilestoneSuccess,
      savingTrackerMilestone,
      saveTrackerMilestoneSuccess,
      validationFailures
    } = this.props;
    if (trackerMilestoneId && prevProps.trackerMilestoneId != trackerMilestoneId) {
      loadTrackerMilestone(trackerMilestoneId);
    } else if (!trackerMilestoneId && prevProps.trackerMilestoneId) {
      createTrackerMilestone();
    }
    if (!loadingTrackerMilestone && prevProps.loadingTrackerMilestone) {
      if (loadTrackerMilestoneSuccess) {
        this.loadForm();
      }
    }
    if (!savingTrackerMilestone && prevProps.savingTrackerMilestone) {
      if (saveTrackerMilestoneSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/settings/qa/trackerMilestones");
        } else if (!form.saveAndReturn && trackerMilestoneId && trackerMilestoneId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !trackerMilestoneId && trackerMilestone && trackerMilestone.id > 0) {
          navigate("/settings/qa/trackerMilestones/" + trackerMilestone.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingTrackerMilestone && prevProps.creatingTrackerMilestone) {
      if (createTrackerMilestoneSuccess) {
        this.loadForm();
      }
    }
  }
  componentWillUpdate(nextProps: TrackerMilestonePageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearTrackerMilestone();
    loadForm(reduxFormName, initialTrackerMilestoneState);
    resetForm(reduxFormName);
  }
  clearTrackerMilestone() {
    this.props.clearTrackerMilestone();
  }
  showTrackerMilestone(): boolean {
    const {
      loadingTrackerMilestone,
      loadTrackerMilestoneSuccess
    } = this.props;
    if (!loadingTrackerMilestone && loadTrackerMilestoneSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrackerMilestone
    } = this.props;
    return <QALookupsLayout loading={loadingTrackerMilestone} permission={Dtos.Permission.TaskTypesView} data-sentry-element="QALookupsLayout" data-sentry-component="TrackerMilestonePage" data-sentry-source-file="TrackerMilestonePage.tsx">
            {this.renderContent()}
        </QALookupsLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingTrackerMilestone,
      permissions
    } = this.props;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TaskTypesUpdate, Dtos.Permission.TaskTypesCreate);
    const formDisabled: boolean = !hasPermission || savingTrackerMilestone || formState && formState.formStatus == Dtos.FormStatus.Disabled;
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      value: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      rank: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " "
      }
    };
    return <div>
            <h1>Tracker Milestone</h1>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {renderFormControls(form, "trackerMilestone", formComponents, lookups, validationFailures, formProperties, changeForm)}
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>

        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
            </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.TrackerMilestone) {
    const {
      saveTrackerMilestone
    } = this.props;
    if (data) {
      let changes: Dtos.TrackerMilestone = ({} as Dtos.TrackerMilestone);
      saveTrackerMilestone(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.TrackerMilestone) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      navigate
    } = this.props;
    navigate("/settings/qa/trackerMilestones");
  }
  loadForm() {
    const {
      loadForm,
      trackerMilestone
    } = this.props;
    let extraData: Dtos.TrackerMilestone = ({} as Dtos.TrackerMilestone);
    loadForm(reduxFormName, Object.assign({
      ...trackerMilestone
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrackerMilestonePageProps): ITrackerMilestonePageProps => {
  let trackerMilestone: Dtos.TrackerMilestone | undefined = !(state.trackerMilestones.formData instanceof Array) ? state.trackerMilestones.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    trackerMilestoneId: ownProps.match && ownProps.match.params.trackerMilestoneId && ownProps.match.params.trackerMilestoneId.toString() != "create" ? ownProps.match.params.trackerMilestoneId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    trackerMilestone: trackerMilestone!,
    loadingTrackerMilestone: state.trackerMilestones.loadState && state.trackerMilestones.loadState.status == RequestState.Pending,
    loadTrackerMilestoneSuccess: state.trackerMilestones.loadState && state.trackerMilestones.loadState.status == RequestState.Success,
    loadTrackerMilestoneFailure: state.trackerMilestones.loadState && state.trackerMilestones.loadState.status == RequestState.Failure,
    savingTrackerMilestone: state.trackerMilestones.saveState && state.trackerMilestones.saveState.status == RequestState.Pending,
    saveTrackerMilestoneSuccess: state.trackerMilestones.saveState && state.trackerMilestones.saveState.status == RequestState.Success,
    saveTrackerMilestoneFailure: state.trackerMilestones.saveState && state.trackerMilestones.saveState.status == RequestState.Failure,
    creatingTrackerMilestone: state.trackerMilestones.createState && state.trackerMilestones.createState.status == RequestState.Pending,
    createTrackerMilestoneSuccess: state.trackerMilestones.createState && state.trackerMilestones.createState.status == RequestState.Success,
    createTrackerMilestoneFailure: state.trackerMilestones.createState && state.trackerMilestones.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: [],
    form: state.reduxForms.trackerMilestone,
    formState: state.trackerMilestones.formState,
    formProperties: state.trackerMilestones.formProperties,
    reduxFormState: state.reduxForms.formState.trackerMilestone,
    validationFailures: trackerMilestone ? state.trackerMilestones.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): ITrackerMilestonePageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadTrackerMilestone: bindActionCreators(TrackerMilestoneActions.LoadTrackerMilestoneById, dispatch),
    clearTrackerMilestone: bindActionCreators(TrackerMilestoneActions.Clear, dispatch),
    saveTrackerMilestone: bindActionCreators(TrackerMilestoneActions.SaveTrackerMilestone, dispatch),
    createTrackerMilestone: bindActionCreators(TrackerMilestoneActions.CreateTrackerMilestone, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrackerMilestonePage);